import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class SubscriberAccessRight {
  public static VIEW_SUBSCRIBERS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
}
